import { lazyLoad } from 'utils/loadable';

export const KitchenOrderPage = lazyLoad(
  () => import('./index'),
  module => module.KitchenOrderPage,
);
